import React from 'react'
import image from '../../Assets/Images/image.jpg'

export default function () {
  return (
    <img src={image} alt="image" className='main-image'/>
  )
}
